import { useEffect, useState } from "react";
import styled from "styled-components";
import { Loading } from "react-vant";
import Select from "../../components/Select";
import {
  LEVELS_SELECT_OPTIONS,
} from "../../utils/constants";

import ECards from "../../components/ECards";
import { getAllCardsAndEquips } from "../../api";
import useEquipModal from "./components/useEquipModal";

import useShop from "./hook/index";
import { useIntl } from "react-intl";
import useCommon from "../../hooks/Common/useCommon";

export default function Shop() {
  const [list, setList] = useState([]);
  const { lang } = useCommon();
  const [searchData, setSearchData] = useState({
    level: "",
  });
  const [loading, setLoading] = useState(true);
  const equipModal = useEquipModal();
  const { redeemEqiup, buyEqiup } = useShop();
  const intl = useIntl();
  useEffect(() => {
    loadAllCard();
  }, [searchData]);
  useEffect(() => {
      localStorage.setItem('RUNBIT_GOODS',JSON.stringify(list))
  },[list])
  const loadAllCard = async () => {
    try {

      let listStorge = localStorage.getItem('RUNBIT_GOODS')
      if(listStorge) {
        setLoading(false);
        listStorge = JSON.parse(listStorge)
        setList(listStorge)
       
      }else {
        setLoading(true);
      }
      const res = await getAllCardsAndEquips({
        ...searchData,
        lang: lang === "en" ? "en" : "cn",
      });
      const l = res.data.list
      l.reverse()
      const l1 = []
      const l2= []
     l.forEach(e => {
      if(e.stock <= e.sales){
        l1.push(e)
      }else {
        l2.push(e)
      }
     })
      setList([...l2,...l1]);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      <FilterRow>
        <Select
          key={"equip"}
          list={LEVELS_SELECT_OPTIONS}
          defaultSelected={""}
          onConfirm={(val, item) => {
            searchData.level = val[0];
            setSearchData({ ...searchData });
          }}
        />
        {/* <Filter
          list={EQUIPS_TYPE_OPTIONS}
          radio={true}
          onConfrim={(val) => {
            searchData.equip_type = val;
            searchData.card_level = "";
            setSearchData({ ...searchData });
          }}
        /> */}
      </FilterRow>
      <ScrollWrapper>
        {loading ? (
          <Loading style={{ marginTop: "20vw" }} size="2.4rem" vertical>
            {intl.formatMessage({
              id: "common.loading",
              defaultMessage: "加載中...",
            })}
          </Loading>
        ) : (
          <ECards //装备
            list={list}
            onClick={(item) => {
              const modal = equipModal.show({
                equip: item,
                onConfrim: async (action) => {
                  modal.close();
                  if (action.key === "1") {
                    //兑换
                    // await redeemEqiup(item);
                  }
                  if (action.key === "2") {
                    // 购买
                    await buyEqiup(item);
                  }
                },
              });
            }}
          />
        )}
      </ScrollWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 0 1.0rem;
`;
const ScrollWrapper = styled.div`
  height: calc(100vh - 16.1rem);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 7.0rem;
  box-sizing: border-box;
`;

const FilterRow = styled.div`
  /* margin: 1.2rem 0 1.0rem; */
  margin-bottom:2.0rem;
  text-align: right;
  /* display: flex;
  justify-content: space-between;
  align-items: center; */
`;
